/**
 * Top-level navigation out of the embedded admin iframe.
 *
 * Assigning `window.top.location` does NOT work here: the app runs in an iframe
 * on a different origin to Shopify Admin, so the browser blocks the navigation
 * and the click silently does nothing. App Bridge patches `window.open` to
 * handle the `_top` target, which is what Shopify's own Managed Pricing docs
 * prescribe for reaching the hosted pricing page.
 */
export function navigateTop(url: string): void {
  try {
    // `_top` escapes the iframe when embedded, and simply navigates the current
    // window when the app is opened standalone.
    const opened = window.open(url, '_top');
    if (opened !== null) return;
  } catch {
    // Fall through to a direct assignment below.
  }
  // Last resort for environments without App Bridge (e.g. local dev outside
  // Shopify Admin), where same-origin assignment is permitted.
  try {
    (window.top ?? window).location.href = url;
  } catch {
    window.location.href = url;
  }
}
